import { render, staticRenderFns } from "./PanelStat.vue?vue&type=template&id=4d5235be&"
import script from "./PanelStat.vue?vue&type=script&lang=js&"
export * from "./PanelStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports